module.exports = __webpack_public_path__ + "static/img/index_swper_06.5b555ee0.png";